import { useEffect } from 'react';
import { Navigate, useNavigate, useSearchParams } from 'react-router-dom';
import { Role } from '@bloomays-lib/types.shared';
import { useAuthStore } from '../../stores';
import { parseCLevelDetailSearchParams } from '../../utils/clevelPrimesDashboard.utils';
import AnnualTamPrimes from '../organisms/AnnualTamPrimes';

const CLevelTamAnnualDetailPage = () => {
  const auth = useAuthStore((state) => state.auth);
  const isSystem = auth?.user?.roles?.includes(Role.System) || false;
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const parseResult = parseCLevelDetailSearchParams(searchParams);

  useEffect(() => {
    const result = parseCLevelDetailSearchParams(searchParams);
    if (result.outcome === 'redirect') {
      navigate('/primes/dashboard', {
        replace: true,
        state: { primesDashboardToastKey: result.toastKey },
      });
    }
  }, [navigate, searchParams]);

  if (!isSystem) {
    return <Navigate to="/forbidden/norole" replace />;
  }

  if (parseResult.outcome === 'redirect') {
    return null;
  }

  return (
    <AnnualTamPrimes
      tamEmail={parseResult.primeContext.tamEmail}
      referenceDate={parseResult.primeContext.referenceDate}
    />
  );
};

export default CLevelTamAnnualDetailPage;
